import { API } from "@/api/api";
import { makePostRequest } from "@/api/fetchCalls";
import { CalculateFormulaResultModel } from "@/domain/model/calculations";

export const addNewCalculateFormulaResult = async (
  questionId: string,
  answers: CalculateFormulaResultModel,
  templateId: string | null | undefined = null,
) => {
  let url = `${API.FORM.CALCULATION_RESULT(questionId)}`;

  if (templateId) {
    url = `${API.FORM.CALCULATION_RESULT(questionId)}?templateId=${templateId}`;
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return (await makePostRequest(url, {
    body: JSON.stringify(answers),
  })) as { result: string };
};
